<template>
    <checkout-step>
        <template slot="title">
            <span @click="currentStep > 3 ? $parent.$parent.jumpTo(3) : null">
                {{ __('Fizetési mód') }}
            </span>
        </template>

        <portal-target
            v-if="portalAvailable"
            name="checkout-payment-mode-before"
        />

        <div
            v-for="mode in paymentModes"
            :key="mode.id"
            class="form-group mb-5"
            :class="{ 'is-invalid' : errors }"
        >
            <div class="form-check d-flex align-items-center my-2 payment-mode-custom-from">
                <input
                    :id="'payment_mode' + mode.id"
                    v-model.number="paymentMode"
                    type="radio"
                    :value="mode.id"
                    class="form-radio w-4 h-4"
                >
                <label
                    class="form-check-label mr-2"
                    :for="'payment_mode' + mode.id"
                    v-html="mode.description"
                >
                </label>
                <img
                    v-if="mode.icon"
                    :src="mode.icon"
                    class="mode-icon"
                    alt="helper image"
                >
            </div>
        </div>

        <portal-target
            v-if="portalAvailable"
            name="checkout-payment-mode-after"
        />

        <form-error
            field="payment_mode"
            :errors="errors"
        />

        <template
            slot="navigation"
            slot-scope="{ prev }"
        >
            <button
                v-if="currentStep !== 1"
                type="button"
                class="btn btn-danger btn-back cart-continue" style="float:left;"
                @click="prev()"
            >
                {{ __('Vissza') }}
            </button>
            <button
                type="button"
                class="btn btn-primary float-right btn-next cart-continue"
                @click="callNext()"
            >
                {{ __('Tovább') }}
            </button>
        </template>
    </checkout-step>
</template>

<script>
import paymentModeBase from '@webapix/shop-js/src//mixins/checkout/paymentModeBase'

export default {
    mixins: [paymentModeBase],

    methods: {
        getPaymentModeName(id) {
            return this.paymentModes.filter(
                item => {
                    return item.id === id
                }
            )[0].name
        },

        callNext() {
            if(this.paymentMode) {
                let _coupons = this.$store.state.cart.discounts.filter(item => typeof item.code !== undefined)
                let _coupon = ''
                if (_coupons.length) {
                    _coupon = _coupons[0].code
                }

                const payload = {
                    items: this.$store.state.cart.items.map(
                        item => {
                            return {
                                id: item.id.identifier,
                                name: item.name,
                                quantity: item.quantity,
                                price: item.price.gross
                            }
                        }
                    ),
                    'coupon': _coupon,
                    'checkout_step': 3,
                    'checkout_option': this.getPaymentModeName(this.paymentMode)
                }

                gtag('event', 'checkout_progress', payload)
            }

            this.$loading.show()
            this.next()
        }
    }
}
</script>

<style lang="scss" scoped>
.form-check-input {
  margin-top: 0 !important;
}

.mode-description >>> p {
  margin-bottom: 0 !important;
}

.mode-icon {
  max-width: 150px;
  max-height: 50px;
}

::v-deep .payment-mode-custom-from {
    p {
        margin-bottom: 0 !important;
    }

    input[type=radio] {
        margin-top: 0 !important;
    }
}
</style>
